import client from '../client';

export const getSponsorList = () => {
  return client.get("/api/v2/article/listByCategory?article.boardCode=007&search.max=100&search.sort=500")
}
